<app-custom-year-picker
  (triggerDateChange)="triggerDateChange($event)"
></app-custom-year-picker>
